import { HorizontalContainer } from '@american-autonomy/ag-ui';

import BoundingBoxLabelTriangleIcon from 'components/icons/BoundingBoxLabelTriangleIcon';

import type { Props } from './types';

import styles from './styles.module.scss';

const BoundingBoxLabelMarker = ({ isActive, isInteractive, isSelected, text }: Props) => {
    const showInteractiveAffordance = isActive && isInteractive;
    const activeContainerStyle = showInteractiveAffordance ? styles.activeContainer : '';
    const interactiveStyle = isInteractive ? styles.interactive : '';

    return (
        <div
            className={`${styles.boundingBoxLabelMarker} ${activeContainerStyle} ${interactiveStyle}`}>
            <HorizontalContainer className={styles.textContainer}>
                <div className={styles.text}>{text}</div>

                {showInteractiveAffordance && (
                    <BoundingBoxLabelTriangleIcon className={styles.boundingBoxLabelTriangleIcon} />
                )}

                {isSelected && <span className={styles.dotContainer}>{'・'}</span>}
            </HorizontalContainer>
        </div>
    );
};

export default BoundingBoxLabelMarker;
